import React from "react";

import { Box, Stack, Divider, Group, Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconDownload, IconShare3 } from "@tabler/icons-react";
import { useRouter } from "next/router";

import { useTrackerUser } from "components/AuthProvider";
import { UpSellButton } from "components/UpSellButton/UpSellButton";
import { useSearchRouteInfo } from "hooks/routing";

import { ExportModal, UpgradeModal } from "./ExportModal";
import { FilterSidebar } from "./FilterSidebar";

export function SearchSidebar(): JSX.Element {
  const { query, queryString } = useSearchRouteInfo();
  const router = useRouter();
  const user = useTrackerUser();
  const [exportModalOpened, { open: openExportModal, close: closeExportModal }] =
    useDisclosure(false);
  const [upgradeModalOpened, { open: openUpgradeModal, close: closeUpgradeModal }] =
    useDisclosure(false);
  const sidebarKey = query.title[0] + query.jobFamily[0] + query.level[0];

  // Check if user is a paid user (has a company ID)
  const isPaidUser = !!user?.companyId;

  // Handle export button click
  const handleExportClick = () => {
    if (isPaidUser) {
      openExportModal();
    } else {
      openUpgradeModal();
    }
  };

  return (
    <Box
      bg="white"
      w={300}
      display={{ base: "none", lg: "block" }}
      sx={{ borderRight: "1px solid #D0D5DD" }}
    >
      <Stack gap={0}>
        <Divider />
        <Group h={60} align="center" px={8} grow>
          <Button
            variant="tertiary"
            size="sm"
            leftSection={<IconDownload size={20} />}
            onClick={handleExportClick}
            styles={{ root: { border: "1px solid var(--mantine-color-gray-3)" } }}
          >
            Export
          </Button>
          <UpSellButton
            variant="tertiary"
            size="sm"
            leftSection={<IconShare3 size={20} />}
            withSparkle={false}
          >
            Share
          </UpSellButton>
        </Group>
        <FilterSidebar key={sidebarKey} />
      </Stack>

      <ExportModal
        opened={exportModalOpened}
        onClose={closeExportModal}
        currentQueryString={queryString}
      />
      <UpgradeModal opened={upgradeModalOpened} onClose={closeUpgradeModal} />
    </Box>
  );
}
